export enum AdminTourAveragesUnits {
  deg = 'deg',
  mph = 'mph',
  rpm = 'rpm',
  yards = 'yards',
  withoutUnit = '',
}

export enum ClubsNames {
  Driver = 'Driver',
  ThreeWood = '3-Wood',
  FiveWood = '5-Wood',
  Hybrid = 'Hybrid',
  ThreeIron = '3 Iron',
  FourIron = '4 Iron',
  FiveIron = '5 Iron',
  SixIron = '6 Iron',
  SevenIron = '7 Iron',
  EightIron = '8 Iron',
  NineIron = '9 Iron',
  PitchingWedge = 'PW',
}

export type AdminClubsScores = {
  driver?: number | null;
  threeWood?: number | null;
  fiveWood?: number | null;
  hybrid?: number | null;
  threeIron?: number | null;
  fourIron?: number | null;
  fiveIron?: number | null;
  sixIron?: number | null;
  sevenIron?: number | null;
  eightIron?: number | null;
  nineIron?: number | null;
  pitchingWedge?: number | null;
};

export type TourAveragesParameter = {
  unit?: string;
  parameterId: string;
  parameterName?: string;
  clubs: AdminClubsScores;
};

export type TourAveragesData = {
  id?: string;
  year: number | null;
  pga: TourAveragesParameter[];
  lpga: TourAveragesParameter[];
};
